import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const bgColor = (theme: Theme, color: string) => {
  // @ts-ignore
  return theme.palette.colors[color];
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      position: 'relative',
    },
    title: {
      width: '100%',
      fontSize: 28,
      color: '#333333',
      fontWeight: 'bold',
      textAlign: 'center',
    },
    gridContainer: {
      paddingTop: 5,
      paddingBottom: 5,
    },
    resetPtop: {
      paddingTop: 0,
    },
    dropzone: {
      outline: 'none',
      padding: theme.spacing(3),
    },
    modalCheck: {
      backgroundColor: '#F8F8F8',
      borderRadius: 10,
      padding: 0,
      marginTop: theme.spacing(3),
    },
    dropzoneCursor: {
      cursor: 'pointer',
    },
    dragActive: {
      borderColor: 'rgba(40,170,170,1)',
    },
    uploadMessage: {
      fontWeight: 300,
      textAlign: 'center',
      fontSize: '1.1em',
      padding: '5px',
    },
    textContainer: {
      marginTop: -theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    helpText: {
      fontWeight: 300,
      fontSize: '0.88em',
      margin: 0,
      marginBottom: 2,
      textAlign: 'center',
    },
    nextButton: {
      minWidth: 135,
      background: `linear-gradient(90deg, ${bgColor(
        theme,
        'blue',
      )} 1.03%, ${bgColor(theme, 'greenDegrade')} 100%)`,
      borderRadius: 20,
      textTransform: 'none',
      color: theme.palette.colors.white,
      marginTop: theme.spacing(2),
    },
    maintainButton: {
      background: theme.palette.colors.gray6,
      color: theme.palette.colors.gray1,
    },
    chooseFileText: {
      color: theme.palette.primary.main,
      fontSize: '0.8rem',
      textDecoration: 'underline',
    },
    closeIconContainer: {
      position: 'absolute',
      right: '-20px',
      top: '-20px',
    },
    container: {
      height: 110,
    },
    csvIconContainer: {
      height: '100%',
      width: 100,
      background: '#eeea',
      borderRadius: '10px 0px 0px 10px',
      padding: 20,
      marginRight: theme.spacing(2),
    },
  }),
);

export default useStyles;
